export default __webpack_public_path__ + "fk-cp-zion/img/grocery-logo_fb537a.svg";